import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Button, Card, CardContent, CardHeader, Grid, Stack, Typography } from "@mui/material";
import { DroppableCard } from "./DroppableCard";
import {
  editGroup,
  editUser,
  groupAddUsers,
  groupMoveUser,
  groupRemoveUser,
  selectActiveDaoTrangId,
  selectGroups,
  selectMembers,
  setGroupChecked,
  updateActiveDaoTrang,
} from "../../features/daoTrang/daoTrangSlice";
import { Content } from "../Content/Content";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { setMoveToCb } from "./dragDrop";
import { updateUser } from "../../services/user/userApi";
import {
  getAllGroups,
  saveGroup,
  updateGroup,
} from "../../services/group/groupApi";
import { selectToken } from "../../features/auth/authSlice";
import { validateGroups } from "../Bcs/Bcs";

const To = ({ navigate, params = {} }) => {
  let { id: daoTrangId } = params;

  const dispatch = useAppDispatch();

  const token = useAppSelector(selectToken);
  const activeDaoTrangId = useAppSelector(selectActiveDaoTrangId);
  const members = useAppSelector(selectMembers);
  const groups = useAppSelector(selectGroups);

  // if navigate form memnu: daoTrangId = activeDaoTrang
  if (!daoTrangId) {
    daoTrangId = activeDaoTrangId;
  }
  useEffect(() => {
    // if navigate form memnu: daoTrangId = activeDaoTrang
    if (!daoTrangId) {
      navigate(-1);
      return;
    }
  }, [daoTrangId, navigate]);

  useEffect(() => {
    async function loader(id) {
      const { result: groups, error } = await getAllGroups(id, token);
      if (error) {
        console.log(error);
      } else {
        // validate groups;
        const changedLst = validateGroups(members, groups, true);

        // save to db
        for await (const g of changedLst) {
          var res = await saveGroup(g);
          if (res.error) {
            console.log(res.error);
          }
        }

        // save
        dispatch(updateActiveDaoTrang({ groups: changedLst }));
      }
    }

    if (!groups) {
      console.log("load groups");
      loader(daoTrangId);
    }
  }, [daoTrangId, dispatch, groups, members, token]);

  function transform(groups) {
    const filtered = groups.filter((g) => g.name.match(/Tổ \d/i));
    const validated = validateGroups(members, filtered);
    var groupO = createGroupO(validated);
    return validated.concat(groupO);
  }

  function createGroupO(groups) {
    var membersDict = new Map();
    members.forEach((u) => membersDict.set(u.email, u));
    groups.forEach(({ subGroups }) =>
      subGroups.forEach((sub) => {
        var { members } = sub;
        sub.users = [];
        members.forEach((email) => {
          sub.users.push(membersDict.get(email));
          membersDict.delete(email);
        });
      })
    );
    var others = {
      name: "others",
      id: null,
      subGroups: [
        {
          name: "members",
          users: Array.from(membersDict.values()),
        },
      ],
    };
    return others;
  }

  const onMoveTo = (dragUser, dragContainer, dropContainer) => {
    console.log({dragUser, dragContainer, dropContainer});
    if (dragContainer.group.name === "others") {
      dispatch(groupAddUsers({ lst:dragUser.email, container: dropContainer }));
    } else if(dropContainer.group.name === "others")  {
      dispatch(groupRemoveUser({ user: dragUser, container: dragContainer }));
    } else {
      dispatch(groupMoveUser({ dragContainer, dragUser, dropContainer }));
    }
  };
  setMoveToCb(onMoveTo);

  const onCheck = useCallback(
    (id, checked) => {
      console.log(id, checked);
      dispatch(setGroupChecked({ id, checked }));
    },
    [dispatch]
  );

  var renderData = groups ? transform(groups) : [];
  console.log({ renderData });

  const onSave = useCallback(() => {
    groups.forEach(async (g) => {
      var { result, error } = await saveGroup(g);
      if (error) {
        console.log(error);
      }
    });
  }, [groups]);

  const footer = (
    <Stack spacing={2} direction="row">
      <Button variant="contained" onClick={onSave}>
        Save
      </Button>
    </Stack>
  );
  const title = (
    <Stack spacing={2} direction="row">
      <Typography variant={"h5"}>Tổ</Typography>
    </Stack>
  );
  return (
    <Content title={title} footer={footer}>
      <Grid
        container
        sx={{
          // minWidth: 600,
          // minHeight: 400,
          overflow: "auto",
          // flexDirection: "column",
          // justifyContent: "center",
          // width: "100%",
          height: "100%",
          // maxWidth: "100%",
        }}
      >
        <Stack
          spacing={{ xs: 1, sm: 2 }}
          direction="row"
          
          flexWrap="nowrap"
          justifyContent="center"
        >
          <DndProvider backend={HTML5Backend}>
            {renderData.map((g, i) => (
              <Card sx={{bgcolor:"primary.light"}}>
                <CardHeader title={g.name}></CardHeader>
                <CardContent>
                  <Stack key={i} spacing={2} direction={"column"}>
                    {g.subGroups.map((sub, j) => (
                      <DroppableCard
                        container={{
                          group: g,
                          name: sub.name,
                          members: sub.users,
                        }}
                        index={j}
                        key={j}
                        onCheck={onCheck}
                        navigate={navigate}
                      />
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            ))}
          </DndProvider>
        </Stack>
      </Grid>
    </Content>
  );
};

export default To;
